"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = void 0;
var utils_1 = require("../../utils");
var react_1 = require("react");
var types_1 = require("./types");
var hooks_1 = require("../../utils/hooks");
var getQueryStatusBooleans = function (setTo) { return Object.fromEntries(types_1.queryStatuses.map(function (s) { return ["is".concat((0, utils_1.capitalize)(s)), s === setTo]; })); };
function initRouteState(routes) {
    var e_1, _a;
    var state = {};
    try {
        for (var routes_1 = __values(routes), routes_1_1 = routes_1.next(); !routes_1_1.done; routes_1_1 = routes_1.next()) {
            var routeName = routes_1_1.value;
            state[routeName] = __assign(__assign({}, getQueryStatusBooleans('idle')), { error: null, status: 'idle' });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (routes_1_1 && !routes_1_1.done && (_a = routes_1.return)) _a.call(routes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return state;
}
function routesStateReducer(state, action) {
    var _a;
    var newRouteState = __assign(__assign({}, state[action.type]), action.payload);
    return __assign(__assign({}, state), (_a = {}, _a[action.type] = __assign(__assign({}, newRouteState), getQueryStatusBooleans(newRouteState.status)), _a));
}
function useQuery(args) {
    var initialState = args.initialState, routes = args.routes;
    var _a = __read((0, react_1.useReducer)(routesStateReducer, Object.keys(routes), initRouteState), 2), queryStates = _a[0], dispatch = _a[1];
    var _b = __read((0, utils_1.usePartialState)({
        data: initialState,
        loading: false,
        hasError: false,
    }), 2), apiState = _b[0], setApiState = _b[1];
    function setRouteState(routeName, newState) {
        dispatch({ type: "".concat(routeName), payload: newState });
    }
    (0, hooks_1.onUpdate)(function () {
        var e_2, _a;
        var newApiState = {
            loading: false,
            hasError: false,
        };
        var queryStateValues = Object.values(queryStates);
        try {
            for (var queryStateValues_1 = __values(queryStateValues), queryStateValues_1_1 = queryStateValues_1.next(); !queryStateValues_1_1.done; queryStateValues_1_1 = queryStateValues_1.next()) {
                var _b = queryStateValues_1_1.value, isError = _b.isError, isLoading = _b.isLoading;
                if (!newApiState.hasError && isError) {
                    newApiState.hasError = true;
                }
                if (!newApiState.loading && isLoading) {
                    newApiState.loading = true;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (queryStateValues_1_1 && !queryStateValues_1_1.done && (_a = queryStateValues_1.return)) _a.call(queryStateValues_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        setApiState(newApiState);
    }, [queryStates]);
    var initialRoutePromises = Object.fromEntries(Object.keys(routes).map(function (name) { return [name, null]; }));
    var promiseRefs = (0, react_1.useRef)(initialRoutePromises);
    function callRoute(name, argument) {
        return __awaiter(this, void 0, void 0, function () {
            var setThisRoute, routeArgs;
            return __generator(this, function (_a) {
                setThisRoute = function (to) { return setRouteState(name, to); };
                setThisRoute({
                    status: 'loading',
                });
                routeArgs = {
                    throwError: function (e) {
                        throw e;
                    },
                    setState: function (to) {
                        setApiState(function (current) {
                            var shouldMerge = !(0, utils_1.isValuePrimitive)(to) && !Array.isArray(to);
                            return {
                                data: shouldMerge ? (0, utils_1.deepMerge)(current.data, to) : to,
                            };
                        });
                    },
                    currentValue: apiState.data,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        promiseRefs.current[name] = routes[name](routeArgs, argument);
                        promiseRefs.current[name].then(function (result) {
                            setThisRoute({
                                status: 'success',
                            });
                            resolve(result);
                            promiseRefs.current[name] = null;
                        });
                        promiseRefs.current[name].catch(function (err) {
                            setThisRoute({
                                status: 'error',
                                error: err,
                            });
                            reject(err);
                            promiseRefs.current[name] = null;
                        });
                    })];
            });
        });
    }
    var routeInterfaces = Object.fromEntries(Object.keys(routes).map(function (name) {
        var callThisRoute = function (argument) { return callRoute(name, argument); };
        var queryInterface = __assign({ send: callThisRoute }, queryStates[name]);
        return [name, queryInterface];
    }));
    return __assign(__assign({}, apiState), { queries: routeInterfaces });
}
exports.useQuery = useQuery;
